// extracted by mini-css-extract-plugin
export var pageBody = "Pantomime-module--pageBody--1aE1C";